import React, { useContext } from "react";

import { Link } from "react-router-dom";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";

import {
    Drawer,
    CssBaseline,
    AppBar,
    Toolbar,
    List,
    Divider,
    IconButton,
    ListItem,
    ListItemIcon,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import HomeIcon from "@material-ui/icons/Home";
import GroupIcon from "@material-ui/icons/Group";
import EventIcon from "@material-ui/icons/Event";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { BiLogOut } from "react-icons/bi";
import PersonAdd from "@material-ui/icons/PersonAdd";
import Redeem from "@material-ui/icons/Redeem";

import StoreContext from "../../utils/Store/Context";
import Enroll from "../../services/enroll";
import Label from "../Label";

import { LogoName } from "./styles";
import ActivityIcon from "@material-ui/icons/List";
import { settings } from "../../config/eventSettings";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    appBar: {
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        background: "linear-gradient(115.6deg, #0a9e9e 0%, #175D90 59.58%, #733BB9 100%)",
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: "flex-end",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create("margin", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    bottomPush: {
        cursor: "pointer",
        bottom: 0,
        padding: "0px 25px 25px",
        position: "fixed",
        textAlign: "center",
    },
}));

const generateButtons = (list) => {
    const buttonConfigs = {
        Home: {
            redirect: "/",
            icon: <HomeIcon />,
        },
        Usuários: {
            redirect: "/users",
            icon: <GroupIcon />,
        },
        Eventos: {
            redirect: "/events",
            icon: <EventIcon />,
        },
        Atividades: {
            redirect: "/activities",
            icon: <ActivityIcon />,
        },
        Solicitações: {
            redirect: "/solicitations",
            icon: <PersonAdd />,
        },
        Itens: {
            redirect: "/materials",
            icon: <Redeem />,
        },
    };

    return list
        .filter((item) => buttonConfigs[item])
        .map((item) => ({
            name: item,
            ...buttonConfigs[item],
        }));
};

const SideBar = (props) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const { setToken, setUser } = useContext(StoreContext);

    const buttons = generateButtons(settings.modules);

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    async function logout() {
        Enroll.logout();
        setToken(null);
        setUser(null);
    }

    const testOnClick = () => console.log("============");

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <LogoName>Truly Event Management</LogoName>
                    <div onClick={testOnClick}>
                        <AccountCircleIcon style={{ fontSize: 30 }} />
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{ paper: classes.drawerPaper }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {buttons.map((button) => (
                        <ListItem
                            selected={props.current === button.name ? true : false}
                            button
                            key={button.name}
                            component={Link}
                            to={button.redirect}
                        >
                            <ListItemIcon>{button.icon}</ListItemIcon>
                            <Label size="nano" color="dark" align="center" padding="10px 0 10px 0">
                                {button.name}
                            </Label>
                        </ListItem>
                    ))}
                </List>
                <Divider />
                <List>
                    <div onClick={logout} style={{ cursor: "pointer" }}>
                        <ListItem key="sair">
                            <ListItemIcon>
                                <BiLogOut size={30} />
                            </ListItemIcon>
                            <Label size="nano" color="dark" align="center" padding="20px 0 20px 0">
                                SAIR
                            </Label>
                        </ListItem>
                    </div>
                </List>
            </Drawer>
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader} />
                {props.content}
            </main>
        </div>
    );
};

export default SideBar;
